import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs/Rx";
import { recruitsemployer} from '../recruits-view.model'
@Injectable()
export class EmployerService{
    public formData12: recruitsemployer;

    constructor(private http:HttpClient){

    }
    onGetRecruitsEmployer(id:number): Observable<boolean> {
        
        return this.http.get(`api/recruits/getrecruitsemployer/${id}`)
            .map( (data:recruitsemployer)=>{
                this.formData12 = data;
                return true;
            });
    }
    onPostRecruitsrecruitsemployerForm(): Observable<boolean> {                    
        return this.http.post(`api/recruits/addrecruitsemployer`, this.formData12,{
            headers:new HttpHeaders()
            .set('Content-Type','application/json')
            })
            .map(()=>{            
                return true;
            });
    }
}